import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1982238a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "billing" }
const _hoisted_2 = { class: "billing__inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-wrap text-truncate" }, "Billing", -1))
const _hoisted_4 = {
  key: 0,
  class: "callout callout--no-max callout--danger mt-2"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reactivate Ditto?", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Oh no!", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 2,
  class: "callout callout--no-max callout--danger mt-2"
}
const _hoisted_11 = {
  key: 3,
  class: "callout callout--no-max callout--danger mt-2"
}
const _hoisted_12 = {
  key: 4,
  class: "dt-container dt-container--tabbed"
}
const _hoisted_13 = { class: "summary" }
const _hoisted_14 = { class: "summary__item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "summary__item-subtitle" }, "Current Plan")
], -1))
const _hoisted_16 = { class: "summary__plan" }
const _hoisted_17 = { class: "summary__plan-type" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary__item-payment-label mt-0" }, "Number of Receivers", -1))
const _hoisted_19 = { class: "summary__plan-cost" }
const _hoisted_20 = {
  key: 0,
  class: "ms-auto"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary__item-payment-label mt-0" }, "Current Price", -1))
const _hoisted_22 = { class: "summary__plan-cost" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_24 = { class: "summary__month-label" }
const _hoisted_25 = { class: "summary__item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary__item-subtitle" }, "Plan Quota", -1))
const _hoisted_27 = { class: "summary__item-quota-items" }
const _hoisted_28 = { class: "summary__item-quota" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary__item-quota-key" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5 20v-1a7 7 0 017-7v0a7 7 0 017 7v1M12 12a4 4 0 100-8 4 4 0 000 8z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Ditto Account Portal users ")
], -1))
const _hoisted_30 = { class: "summary__item-quota-value" }
const _hoisted_31 = { class: "summary__item-quota" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary__item-quota-key" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7 21h10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M2 16.4V3.6a.6.6 0 01.6-.6h18.8a.6.6 0 01.6.6v12.8a.6.6 0 01-.6.6H2.6a.6.6 0 01-.6-.6z" })
  ]),
  /*#__PURE__*/_createTextVNode(" Receivers ")
], -1))
const _hoisted_33 = { class: "summary__item-quota-value" }
const _hoisted_34 = { class: "summary__item-quota" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary__item-quota-key" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M5 12v6s0 3 7 3 7-3 7-3v-6" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M5 6v6s0 3 7 3 7-3 7-3V6" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M12 3c7 0 7 3 7 3s0 3-7 3-7-3-7-3 0-3 7-3z" })
  ]),
  /*#__PURE__*/_createTextVNode(" Storage ")
], -1))
const _hoisted_36 = { class: "summary__item-quota-value" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "A receiver is active when it’s linked to a Ditto room.", -1))
const _hoisted_38 = { class: "summary__item" }
const _hoisted_39 = { class: "d-flex" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary__item-subtitle summary__item-subtitle--flex" }, "Payment Information", -1))
const _hoisted_41 = {
  key: 0,
  class: "pb-2"
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = { key: 2 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = {
  key: 0,
  class: "summary__item-payment-edit"
}
const _hoisted_51 = {
  key: 0,
  class: "summary__item-payment-label primary-color"
}
const _hoisted_52 = {
  key: 2,
  class: "callout callout--warning"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "You do not have permission to edit your subscription. Contact your organization’s Ditto Account Portal administrator.", -1))
const _hoisted_54 = { class: "tier-card-section" }
const _hoisted_55 = {
  key: 0,
  class: "tier-card-divider"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tier-card-divider__inner" }, "OR", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = {
  key: 1,
  class: "tier-card tier-card--po"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 21.4V2.6a.6.6 0 01.6-.6h11.652a.6.6 0 01.424.176l3.148 3.148A.6.6 0 0120 5.75V21.4a.6.6 0 01-.6.6H4.6a.6.6 0 01-.6-.6zM8 10h8M8 18h8M8 14h4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16 2v3.4a.6.6 0 00.6.6H20",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tier-card__po-content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Request a Purchase Order"),
  /*#__PURE__*/_createElementVNode("p", null, "Contact the Ditto team to pay via purchase order.")
], -1))
const _hoisted_61 = { class: "m-0" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, [
  /*#__PURE__*/_createTextVNode("Enter the total number of Ditto receivers needed for your account. A Ditto representative will contact you to complete your purchase. For immediate assistance, call "),
  /*#__PURE__*/_createElementVNode("strong", null, "1-888-881-2503"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Additional information")
], -1))
const _hoisted_64 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_payment_summary = _resolveComponent("payment-summary")!
  const _component_adjust_plan_subscription = _resolveComponent("adjust-plan-subscription")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_compare_plans = _resolveComponent("compare-plans")!
  const _component_payment_history_invoices = _resolveComponent("payment-history-invoices")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_SubscriptionPaymentModal = _resolveComponent("SubscriptionPaymentModal")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.stripeCardErrorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Icon, {
              class: "icon icon--x-large icon--danger",
              icon: _ctx.mdiAlertCircle
            }, null, 8, ["icon"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.stripeCardErrorMessage), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isTrial && _ctx.trialExtension)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["callout callout--no-max callout--danger mt-2 d-flex justify-content-between", {'flex-column' : _ctx.windowWidth.value < 576}])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["d-flex align-items-center float-start", {'mb-3' : _ctx.windowWidth.value < 576}])
            }, [
              _createVNode(_component_Icon, {
                class: "icon icon--x-large icon--danger",
                icon: _ctx.mdiAlertCircle
              }, null, 8, ["icon"]),
              (_ctx.trialExtension === 'renew' && _ctx.hasBilling)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(" Your trial has expired. However, you can try Ditto again for 30 days.")
                  ]))
                : (_ctx.trialExtension === 'expired' || (!_ctx.hasBilling && _ctx.trialExtension === 'renew'))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _hoisted_8,
                      _createTextVNode(" Your trial has expired. " + _toDisplayString(_ctx.hasBilling ? 'Purchase a plan and keep sharing!' : 'Contact your organization’s Ditto Account Portal administrator.'), 1)
                    ]))
                  : _createCommentVNode("", true)
            ], 2),
            (_ctx.trialExtension === 'renew' && _ctx.hasBilling)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createVNode(_component_el_button, {
                    class: "ms-0 mb-2 me-2 float-end",
                    type: "primary",
                    onClick: _ctx.reactivateTrial
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Reactivate Trial")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (!_ctx.isTrial && !_ctx.isSubscriptionActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_Icon, {
              class: "icon icon--x-large icon--danger",
              icon: _ctx.mdiAlertCircle
            }, null, 8, ["icon"]),
            _createElementVNode("span", null, "Your subscription is expired. " + _toDisplayString(!_ctx.hasBilling ? 'Contact your organization’s Ditto Account Portal administrator to purchase a plan.' : _ctx.isPO ? 'Contact your Ditto representative to purchase a plan.' : 'Purchase a plan to use Ditto.'), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.currrentTier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_Icon, {
              class: "icon icon--x-large icon--danger",
              icon: _ctx.mdiAlertCircle
            }, null, 8, ["icon"]),
            _createElementVNode("span", null, "You have not selected a Ditto plan. " + _toDisplayString(!_ctx.hasBilling ? 'Contact your organization’s Ditto Account Portal administrator to purchase a plan.' : _ctx.isPO ? 'Contact your Ditto representative to select a plan.' : 'Select a plan below.'), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.viewLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_el_tabs, {
              modelValue: _ctx.activeTab,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeTab) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "My Account",
                  name: "myAccount"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_13, [
                      _createElementVNode("article", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currrentTier.name ?? 'Select a plan'), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["mb-auto", {'d-flex': _ctx.windowWidth.value >= 576}])
                        }, [
                          _createElementVNode("div", null, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.subscriptionLimit), 1)
                            ])
                          ]),
                          (!_ctx.isPO && !_ctx.isTrial && _ctx.currrentTier)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.formattedAmount), 1),
                                  _hoisted_23,
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.organization.billing.billingFrequency), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["ms-auto", {'pt-3': _ctx.windowWidth.value < 576}])
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.expirationText), 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.expirationDate), 1)
                        ], 2)
                      ]),
                      _createVNode(_component_el_divider, {
                        direction: _ctx.windowWidth.value >= 576 ? 'vertical' : 'horizontal',
                        class: _normalizeClass({'summary-divider--vertical' : _ctx.windowWidth.value >= 576, 'summary-divider--horizontal': _ctx.windowWidth.value < 576})
                      }, null, 8, ["direction", "class"]),
                      _createElementVNode("article", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.orgUserUsage), 1)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.orgReceiverUsage), 1)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.orgStorageUsage), 1)
                          ])
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["primary-color", {'pt-4': _ctx.windowWidth.value < 576}])
                        }, [
                          _createVNode(_component_Icon, {
                            class: "icon icon--small icon--color me-1 mb-1",
                            icon: _ctx.mdiInformationOutline
                          }, null, 8, ["icon"]),
                          _hoisted_37
                        ], 2)
                      ]),
                      _createVNode(_component_el_divider, {
                        direction: _ctx.windowWidth.value >= 576 ? 'vertical' : 'horizontal',
                        class: _normalizeClass({'summary-divider--vertical' : _ctx.windowWidth.value >= 576, 'summary-divider--horizontal': _ctx.windowWidth.value < 576})
                      }, null, 8, ["direction", "class"]),
                      _createElementVNode("article", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", null, [
                            _hoisted_40,
                            (_ctx.hasBilling && _ctx.customer && _ctx.customer.shipping && !_ctx.isPO && !_ctx.isTrial)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.customer.shipping.name), 1),
                                  (_ctx.customer.shipping.address.line1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                        _hoisted_43,
                                        _createTextVNode(_toDisplayString(_ctx.customer.shipping.address.line1), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.customer.shipping.address.line2)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                        _hoisted_45,
                                        _createTextVNode(_toDisplayString(_ctx.customer.shipping.address.line2), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", null, [
                                    _hoisted_46,
                                    _createTextVNode(_toDisplayString(_ctx.customer.shipping.address.city) + ", " + _toDisplayString(_ctx.customer.shipping.address.state) + " " + _toDisplayString(_ctx.customer.shipping.address.postal_code), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_47,
                                    _createTextVNode(_toDisplayString(_ctx.customer.shipping.address.country), 1)
                                  ]),
                                  (_ctx.customer.vat_number)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                                        _hoisted_49,
                                        _createTextVNode("VAT Number: " + _toDisplayString(_ctx.customer.vat_number), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.canEditPayment)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isUpdatePaymentModalVisible = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Edit")
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.hasBilling)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.isTrial ? 'Trial' : _ctx.isPO ? "Purchase Order" : "Credit Card"), 1))
                          : _createCommentVNode("", true),
                        (_ctx.hasBilling)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["summary_item-cc-item", {'summary__item-po' : _ctx.isPO, 'summary_item-payment-item': _ctx.isPO || _ctx.isTrial}])
                            }, [
                              _createVNode(_component_payment_summary, { expirationDate: _ctx.expirationDate }, null, 8, ["expirationDate"])
                            ], 2))
                          : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createVNode(_component_Icon, {
                                class: "icon icon--x-large icon--warning",
                                icon: _ctx.mdiAlertCircle
                              }, null, 8, ["icon"]),
                              _hoisted_53
                            ]))
                      ])
                    ]),
                    _createElementVNode("section", _hoisted_54, [
                      _createElementVNode("article", {
                        class: _normalizeClass(["tier-card", {'tier-card--currentplancallout': _ctx.organization.tierId === 'basic'}])
                      }, [
                        _createVNode(_component_adjust_plan_subscription, {
                          plan: _ctx.getPlan('basic'),
                          organization: _ctx.organization,
                          isPO: _ctx.isPO,
                          billingFrequency: _ctx.billingFrequency,
                          numberOfReceivers: _ctx.numberOfReceivers,
                          currentReceiverCount: _ctx.subscriptionLimit,
                          isUpdate: _ctx.isUpdate,
                          isCurrentPlan: _ctx.organization.tierId === 'basic',
                          hasBilling: _ctx.hasBilling,
                          allowPurchaseOrChange: _ctx.allowPurchaseOrChange,
                          onIsSaving: _ctx.onSaving,
                          onGoToComparePlans: _ctx.goToComparePlans,
                          onUpdateReceiverCount: _ctx.updateNumberOfReceivers,
                          onUpdateFequency: _ctx.updateFequency,
                          onUpdateSubscription: _ctx.onUpdateSubscription
                        }, null, 8, ["plan", "organization", "isPO", "billingFrequency", "numberOfReceivers", "currentReceiverCount", "isUpdate", "isCurrentPlan", "hasBilling", "allowPurchaseOrChange", "onIsSaving", "onGoToComparePlans", "onUpdateReceiverCount", "onUpdateFequency", "onUpdateSubscription"])
                      ], 2),
                      _createElementVNode("article", {
                        class: _normalizeClass(["tier-card", {'tier-card--currentplancallout': _ctx.organization.tierId === 'premium', 'tier-card--recommendedplancallout': _ctx.showRecommended}])
                      }, [
                        _createVNode(_component_adjust_plan_subscription, {
                          plan: _ctx.getPlan('premium'),
                          organization: _ctx.organization,
                          isPO: _ctx.isPO,
                          billingFrequency: _ctx.billingFrequency,
                          currentReceiverCount: _ctx.subscriptionLimit,
                          numberOfReceivers: _ctx.numberOfReceivers,
                          isUpdate: _ctx.isUpdate,
                          isCurrentPlan: _ctx.organization.tierId === 'premium',
                          hasBilling: _ctx.hasBilling,
                          allowPurchaseOrChange: _ctx.allowPurchaseOrChange,
                          onIsSaving: _ctx.onSaving,
                          onGoToComparePlans: _ctx.goToComparePlans,
                          onUpdateReceiverCount: _ctx.updateNumberOfReceivers,
                          onUpdateFequency: _ctx.updateFequency,
                          onUpdateSubscription: _ctx.onUpdateSubscription
                        }, null, 8, ["plan", "organization", "isPO", "billingFrequency", "currentReceiverCount", "numberOfReceivers", "isUpdate", "isCurrentPlan", "hasBilling", "allowPurchaseOrChange", "onIsSaving", "onGoToComparePlans", "onUpdateReceiverCount", "onUpdateFequency", "onUpdateSubscription"])
                      ], 2),
                      _createElementVNode("article", {
                        class: _normalizeClass(["tier-card", {'tier-card--currentplancallout': _ctx.organization.tierId === 'elite' || _ctx.organization.tierId === 'trial'}])
                      }, [
                        _createVNode(_component_adjust_plan_subscription, {
                          plan: _ctx.getPlan('elite'),
                          organization: _ctx.organization,
                          isPO: _ctx.isPO,
                          billingFrequency: _ctx.billingFrequency,
                          numberOfReceivers: _ctx.numberOfReceivers,
                          currentReceiverCount: _ctx.subscriptionLimit,
                          isUpdate: _ctx.isUpdate,
                          isCurrentPlan: _ctx.organization.tierId === 'elite',
                          hasBilling: _ctx.hasBilling,
                          allowPurchaseOrChange: _ctx.allowPurchaseOrChange,
                          onIsSaving: _ctx.onSaving,
                          onGoToComparePlans: _ctx.goToComparePlans,
                          onUpdateReceiverCount: _ctx.updateNumberOfReceivers,
                          onUpdateFequency: _ctx.updateFequency,
                          onUpdateSubscription: _ctx.onUpdateSubscription,
                          onRequestPO: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openPoModal(true)))
                        }, null, 8, ["plan", "organization", "isPO", "billingFrequency", "numberOfReceivers", "currentReceiverCount", "isUpdate", "isCurrentPlan", "hasBilling", "allowPurchaseOrChange", "onIsSaving", "onGoToComparePlans", "onUpdateReceiverCount", "onUpdateFequency", "onUpdateSubscription"])
                      ], 2),
                      (!_ctx.isPO && _ctx.hasBilling)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_57))
                        : _createCommentVNode("", true),
                      (!_ctx.isPO && _ctx.hasBilling)
                        ? (_openBlock(), _createElementBlock("article", _hoisted_58, [
                            _hoisted_59,
                            _hoisted_60,
                            _createVNode(_component_el_button, {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openPoModal(false))),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Make Purchase Order")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Compare Plans",
                  name: "comparePlans"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_compare_plans, {
                      subscriptionPlan: _ctx.organization.tierId,
                      showTrial: false
                    }, null, 8, ["subscriptionPlan"])
                  ]),
                  _: 1
                }),
                (_ctx.hasBilling && !_ctx.isPO)
                  ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: 0,
                      label: "Payment History & Invoicing",
                      name: "paymentHistoryInvoicing"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_payment_history_invoices, {
                          key: _ctx.keyIndex,
                          isCanceled: _ctx.isCanceled,
                          isSubscriptionActive: _ctx.isSubscriptionActive,
                          isPO: _ctx.isPO,
                          billingInterval: _ctx.billingFrequency
                        }, null, 8, ["isCanceled", "isSubscriptionActive", "isPO", "billingInterval"]))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.purchaseOrderModalVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.purchaseOrderModalVisible) = $event)),
      onClose: _ctx.onCancelPo
    }, {
      title: _withCtx(() => [
        _createElementVNode("h2", _hoisted_61, _toDisplayString(_ctx.poHeader), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_64, [
          _createVNode(_component_el_button, {
            onClick: _ctx.onCancelPo,
            disabled: _ctx.purchaseOrderSubmitting
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onSubmitPurchaseOrder,
            disabled: _ctx.purchaseOrderSubmitting
          }, {
            default: _withCtx(() => [
              _createTextVNode("Submit")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "po-form",
          ref: "purchaseOrderForm",
          model: _ctx.purchaseOrderForm,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _hoisted_62,
            _createVNode(_component_el_form_item, { prop: "numberOfReceivers" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  class: "el-input-number--large mt-4",
                  modelValue: _ctx.purchaseOrderForm.numberOfReceivers,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.purchaseOrderForm.numberOfReceivers) = $event)),
                  modelModifiers: { number: true },
                  min: "1"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "additionalInformation",
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                _hoisted_63,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.additionalInformation,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.additionalInformation) = $event)),
                  rows: 5,
                  type: "textarea",
                  placeholder: _ctx.poPlaceholder
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"]),
    _createVNode(_component_SubscriptionPaymentModal, {
      modelValue: _ctx.isUpdatePaymentModalVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isUpdatePaymentModalVisible) = $event)),
      isUpdate: true,
      onModalClosed: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isUpdatePaymentModalVisible = false)),
      onUpdatePayment: _ctx.onUpdatePayment
    }, null, 8, ["modelValue", "onUpdatePayment"])
  ])), [
    [_directive_loading, _ctx.viewLoading]
  ])
}